import { render, staticRenderFns } from "./DeleteBlock.vue?vue&type=template&id=ce041448&scoped=true&"
import script from "./DeleteBlock.vue?vue&type=script&lang=js&"
export * from "./DeleteBlock.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBlock.vue?vue&type=style&index=0&id=ce041448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce041448",
  null
  
)

export default component.exports